export default "__VITE_ASSET__7c69405d__"